// @flow
import React, {useState} from 'react';
import type {ComponentType, Node} from 'react';
import {observer} from 'mobx-react';
import {Modal} from '@mui/material';
import {Box, Stack, Typography} from '@wellstone-solutions/web';
import {Theme} from '@wellstone-solutions/common';

import {CreateWizard} from '../CreateWizard';
import {useStores} from 'hooks/useStores';
import {useFeatureFlag, LD_FLAGS} from 'modules/feature-flags';
import {MEMBER_LIST_DESCRIPTION} from '../../constants';
import {AccessControl} from 'modules/rbac';
import {ActionButton} from 'components/PageHeader';

export const ListHeader: ComponentType<{}> = observer((): Node => {
  const [showModal, setShowModal] = useState(false);
  const {RBACStore} = useStores();
  const emrManagedUsers = useFeatureFlag(LD_FLAGS.EMR_MANAGED_USERS);

  const toggleModal = (event, reason) => {
    if (reason !== 'backdropClick') {
      setShowModal(!showModal);
    }
  };

  return (
    <Stack direction="row" justifyContent="space-between" sx={{mb: 4}}>
      <Box>
        <Typography variant="h1" sx={styles.title}>
          Members
        </Typography>
        <Typography variant="body" sx={{display: {xs: 'none', md: 'block'}}}>
          {MEMBER_LIST_DESCRIPTION}
        </Typography>
      </Box>
      <Box>
        {RBACStore.hasAccess(AccessControl.members.addMember) &&
          !emrManagedUsers && (
            <Box>
              <ActionButton
                onClick={() => setShowModal(true)}
                label="New Member"
                testId="add-new-member-button"
              />
              <Modal open={showModal} onClose={toggleModal}>
                <div>
                  <CreateWizard onCancel={toggleModal} />
                </div>
              </Modal>
            </Box>
          )}
      </Box>
    </Stack>
  );
});

const styles = {
  title: {
    fontSize: '32px',
    lineHeight: '42px',
    fontWeight: '700',
    color: Theme.colorPalette.darkest,
  },
};
